module.exports = __webpack_public_path__ + "static/media/karen.524c29cc.png";